import { Avatar, AvatarProps, makeStyles, Theme, Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

export type UserDetails = {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  img?: string;
};

export type UserAvatarProps = AvatarProps & {
  user: UserDetails;
};

const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    fontSize: 10,
    height: 24,
    letterSpacing: -1,
    lineHeight: 20,
    width: 24,
  },
}));

export const UserAvatar = ({ user, className, ...props }: UserAvatarProps): JSX.Element => {
  const classes = useStyles();
  const name = user.displayName || `${user.firstName} ${user.lastName}`;

  return (
    <Tooltip arrow title={name}>
      <Avatar className={clsx(classes.avatar, className)} src={user.img} {...props} data-testid={'user-avatar'}>
        {user.displayName
          ? user.displayName[0].toUpperCase()
          : `${user.firstName[0].toUpperCase()}${user.lastName[0].toUpperCase()}`}
      </Avatar>
    </Tooltip>
  );
};

export default UserAvatar;
